// extracted by mini-css-extract-plugin
module.exports = {"base":"RoutePagination_base__p4WWA"};